export default __webpack_public_path__ + "static/media/Success.71f3f7a6.gif";